import { render, staticRenderFns } from "./Sentiment.vue?vue&type=template&id=2affbef7&"
import script from "./Sentiment.vue?vue&type=script&lang=js&"
export * from "./Sentiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports